export default {
    CENTRAL: 'central',
    ELECTRIC: 'electric',
    FIREPLACE: 'fireplace',
    FIREPLACE_INSERTS: 'fireplace-inserts',
    HEAT_PUMP: 'heat-pump',
    OIL_ELECTRIC_WOOD: 'oil-electric-wood',
    GAS_WOOD: 'gas-wood',
    PELLET_STOVE: 'pellet-stove',
    RADIANT: 'radiant',
    SOLAR: 'solar',
    SOLID_FUEL: 'solid-fuel',
    SPACE_HEATER: 'space-heater',
    STOVE: 'stove',
    WOOD_BURNING: 'wood-burning',
    OTHER: 'other',
};
